import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { JOURNAL_ENTRY } from "./apiRoutes";

interface UseGetJournalEntryListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getJournalEntryList = async (data: any) =>
  await axiosAuth.post(`${JOURNAL_ENTRY}/grid`, data);

const useGetJournalEntryList = ({
  data,
  queryParams,
}: UseGetJournalEntryListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["journal-entries"],
    queryFn: () => getJournalEntryList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetJournalEntryList;
